import { FC } from 'react'

import styled from 'styled-components'

import { Offer } from 'src/Redux/api/offersApi'

import { ModelEquipmentSelector } from './ModelEquipmentSelector'
import { EquipmentSelection } from './useCreateContract'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
`

interface EquipmentSelectionStepProps {
  offer?: Offer
  selectedEquipments: Record<number, EquipmentSelection[]>
  onEquipmentSelect: (
    offerModelId: number,
    index: number,
    equipmentId: number | null,
  ) => void
  onWorkTypeChange: (
    offerModelId: number,
    index: number,
    workType: string,
  ) => void
  onShiftsCountChange: (
    offerModelId: number,
    index: number,
    shiftsCount: number | null,
  ) => void
  onMinHoursPerShiftChange: (
    offerModelId: number,
    index: number,
    minHoursPerShift: number,
  ) => void
}

export const EquipmentSelectionStep: FC<EquipmentSelectionStepProps> = ({
  offer,
  selectedEquipments,
  onEquipmentSelect,
  onWorkTypeChange,
  onShiftsCountChange,
  onMinHoursPerShiftChange,
}) => {
  if (!offer || !offer.offerModels || offer.offerModels.length === 0) {
    return (
      <Container>
        <div>Нет моделей в коммерческом предложении</div>
      </Container>
    )
  }

  return (
    <Container>
      {offer.offerModels.map((offerModel) => {
        const count = offerModel.count || 1
        const selectedForThisModel =
          selectedEquipments[offerModel.id] ||
          Array(count).fill({
            equipmentId: null,
            workType: '',
            shiftsCount: null,
            minHoursPerShift: 10,
          })

        return (
          <ModelEquipmentSelector
            key={offerModel.id}
            offerModel={offerModel}
            selectedEquipments={selectedForThisModel}
            onEquipmentSelect={(index, equipmentId) =>
              onEquipmentSelect(offerModel.id, index, equipmentId)
            }
            onWorkTypeChange={(index, workType) =>
              onWorkTypeChange(offerModel.id, index, workType)
            }
            onShiftsCountChange={(index, shiftsCount) =>
              onShiftsCountChange(offerModel.id, index, shiftsCount)
            }
            onMinHoursPerShiftChange={(index, minHoursPerShift) =>
              onMinHoursPerShiftChange(offerModel.id, index, minHoursPerShift)
            }
          />
        )
      })}
    </Container>
  )
}
